import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CryptoJS from 'crypto-js';
import { QueryClient, QueryClientProvider } from "react-query";
import { actionTypes, useStateValue } from "./store";
import { useCookies } from "react-cookie";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { HelmetProvider } from 'react-helmet-async';
import { Modal } from 'react-bootstrap';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Home from './pages/Home';
import Dashboard from "./pages/Myaccount/Dashboard";
import LoginForm from "./pages/Login/LoginForm";
import CloseIcon from '@mui/icons-material/Close';
import AboutUs from "./pages/StaticPages/AboutUs";
import PrivacyPolicy from "./pages/StaticPages/PrivacyPolicy";
import Compare from "./pages/Compare/Compare";
import EditProfile from "./pages/Myaccount/EditProfile";
import AddBusinessProfile from "./pages/Myaccount/AddBusinessProfile";
import ManageAddresses from "./pages/Myaccount/ManageAddresses";
import UpdateAddress from "./pages/Myaccount/UpdateAddress";
import MyWishList from "./pages/Myaccount/MyWishList";
import MyOrders from "./pages/Myaccount/MyOrders";
import OrderDetails from "./pages/Myaccount/OrderDetails";
import Page from "./pages/Investors/Page";
import ProductDetail from "./pages/Product/ProductDetail";
import EditAddress from "./pages/Myaccount/EditAddress";
import CategoryList from "./pages/Category/CategoryList";
import CheckoutPage from "./pages/Cart/CheckoutPage";
import SinglePage from "./pages/PressRelease/SinglePage";
import PressReleaseListing from "./pages/PressRelease/PressReleaseListing";
import InvestorsListing from "./pages/Investors/InvestorsListing";
import OnlinePayment from "./pages/StaticPages/OnlinePayment";
import ContactUs from "./pages/StaticPages/ContactUs";
import ServiceNetwork from "./pages/StaticPages/ServiceNetwork";
import Calculator from "./pages/StaticPages/Calculator";
import HondaGenuineOil from "./pages/StaticPages/HondaGenuineOil";
import ExtendedWarranty from "./pages/StaticPages/ExtendedWarranty";
import ExportsLP from "./pages/StaticPages/Exports/ExportsLP";
import CareersLP from "./pages/Careers/CareersLP";
import WhyBuyHonda from "./pages/StaticPages/WhyBuyHonda";
import NoFound from "./pages/StaticPages/NoFound";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from "@mui/material";
import ResponseCheckout from "./pages/CheckoutResponse/ResponseCheckout";
import ManageBilling from "./pages/Myaccount/ManageBilling";
import UpdateBillingAddress from "./pages/Myaccount/UpdateBillingAddress";
import EditBillingAddress from "./pages/Myaccount/EditBillingAddress";
import EventListing from "./pages/Events/EventListing";
import EventDetails from "./pages/Events/EventDetails";
import FAQs from "./pages/StaticPages/FAQs";
import ReturnPolicy from "./pages/StaticPages/ReturnPolicy";
import TermsofUse from "./pages/StaticPages/TermsofUse";
import Sitemap from "./pages/StaticPages/Sitemap";
import { logoutcustomer } from "./networkCalls";
import BecomeADealer from "./pages/BecomeADealer/BecomeADealer";
import BlogListing from "./pages/Blog/BlogListing";
import BlogDetails from "./pages/Blog/BlogDetails";
import CategoryListOEM from "./pages/Category/CategoryListOEM";
import ProductDetailOEM from "./pages/Product/ProductDetailOEM";
import OemRegsitration from "./pages/OemRegistration/OemRegsitration";
import EWasteManagement from "./pages/StaticPages/EWasteManagement";
import BoardOfDirectorsListing from "./pages/BoardOfDirectors/BoardOfdirectors";
import ScrollToTop from "./ScrolltoTop";
import StickySidebar from "./stickysidebar";



const queryClient = new QueryClient();
function App() {

  const helmetContext = {};

  {/* for login popup */ }
  const handleCloseLogin = () => {
    dispatch({ type: actionTypes.SET_LOGINMODAL, value: false });
  }
  // for snackbar msgalert alert
  const [state, setState] = React.useState({
    vertical: 'top',
    horizontal: 'bottom',
  });
  const { vertical, horizontal } = state;

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  // end snackbar msgalert alert

  const [cookie, setCookie, removeCookie] = useCookies(["jwt", "huid", "hdetial"]);
  const [{ token, huid, loginmodal, msgalert, msgalertMessage, msgalertType, tokenmodal }, dispatch] = useStateValue();
  useEffect(() => {

    const setToken = () => {
      const { jwt, huid } = cookie;
      if (jwt) {
        // dispatch({ type: actionTypes.SET_TOKEN, value: jwt });
        var temp_xID = CryptoJS.AES.decrypt(jwt, 'HON_MX46d67ee5d05');
        var xID = temp_xID.toString(CryptoJS.enc.Utf8);
        dispatch({ type: actionTypes.SET_TOKEN, value: xID });
      }
      if (huid) {
        // dispatch({ type: actionTypes.SET_HUID, value: huid });
        var temp_uType = CryptoJS.AES.decrypt(huid, 'HON_MX46d67ee5d05');
        var xUType = temp_uType.toString(CryptoJS.enc.Utf8);
        dispatch({ type: actionTypes.SET_HUID, value: xUType });
      }
    };
    if (token === null) {
      setToken();
    }

  }, [dispatch, token, cookie]);

  const handleCloseMsgalert = () => {
    dispatch({ type: actionTypes.SET_MSGALERT, value: false });
  }

  const logout = () => {
    var data = new FormData();
    data.append('customerId', huid);
    data.append('XAuth', token);
    logoutcustomer(data).then((res) => {
      switch (res.data.status) {
        case 1:
          removeCookie("jwt", { path: "/" });
          removeCookie("huid", { path: "/" });
          removeCookie("hdetial", { path: "/" });
          dispatch({ type: actionTypes.SET_TOKEN, value: null });
          dispatch({ type: actionTypes.SET_HUID, value: null });
          dispatch({ type: actionTypes.SET_WISHLISTCOUNT, value: '0' });
          dispatch({ type: actionTypes.SET_WISHLISTALLID, value: null });
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: false });
          window.location.href = "/"
          return true;
        case 0:
          dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
          dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
          dispatch({ type: actionTypes.SET_MSGALERT, value: true });
          break;
        case 2:
          removeCookie("jwt", { path: "/" });
          removeCookie("huid", { path: "/" });
          removeCookie("hdetial", { path: "/" });
          dispatch({ type: actionTypes.SET_TOKEN, value: null });
          dispatch({ type: actionTypes.SET_HUID, value: null });
          dispatch({ type: actionTypes.SET_WISHLISTCOUNT, value: '0' });
          dispatch({ type: actionTypes.SET_WISHLISTALLID, value: null });
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: false });
          window.location.href = "/"
          break;
        default:
          return;
      }
    })
  }


  return (
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ScrollToTop/>
          <StickySidebar/>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/myaccount/dashboard' element={token ? <Dashboard /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/edit-profile' element={token ? <EditProfile /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/add-business-profile' element={token ? <AddBusinessProfile /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/manage-addresses' element={token ? <ManageAddresses /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/update-address' element={token ? <UpdateAddress /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/billing-addresses' element={token ? <ManageBilling /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/update-billing' element={token ? <UpdateBillingAddress /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/manage-wishlist' element={token ? <MyWishList /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/manage-orders' element={token ? <MyOrders /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/order-details/:pageSlug' element={token ? <OrderDetails /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/edit-address' element={token ? <EditAddress /> : <p>Plasse Login</p>} />
            <Route path='/myaccount/edit-billing-address' element={token ? <EditBillingAddress /> : <p>Plasse Login</p>} />
            <Route path='/product-detail/:productID' element={<ProductDetail />} />
            <Route path='/product-category/:categorySlug' element={<CategoryList />} />

            <Route path='/oem-category/:categorySlug' element={<CategoryListOEM />} />
            <Route path='/oem-category/:inventoryItemId/:name/:productID' element={<ProductDetailOEM />} />

            <Route path='/compare' element={<Compare />} />
            <Route path='/checkout' element={<CheckoutPage />} />
            <Route path='/investors/' element={<InvestorsListing />} />
            <Route path='/investors/:investorURL' element={<Page />} />
            {/* <Route path='/press-release' element={<PressReleaseListing />} /> */}
           
            <Route path='/press-release/:pageSlug' element={<SinglePage />} />

            <Route path='/events' element={<EventListing />} />
            <Route path='/events/:pageSlug' element={<EventDetails />} />

            <Route path='/blog' element={<BlogListing />} />
            <Route path='/blog/:pageSlug' element={<BlogDetails />} />

            {/* for static page */}
            <Route path='/about-us' element={<AboutUs />} />
            <Route path='/sitemap' element={<Sitemap />} />
            <Route path='/become-a-dealer' element={<BecomeADealer />} />

            <Route path='/oem-registration' element={<OemRegsitration />} />
            
            <Route path='/faqs' element={<FAQs />} />
            <Route path='/why-buy-a-honda' element={<WhyBuyHonda />} />
            <Route path='/contact-us' element={<ContactUs />} />
            <Route path='/service-network' element={<ServiceNetwork />} />
            <Route path='/calculator' element={<Calculator />} />
            <Route path='/honda-genuine-oil' element={<HondaGenuineOil />} />
            <Route path='/extended-warranty' element={<ExtendedWarranty />} />
            <Route path='/exports' element={<ExportsLP />} />
            {/* <Route path='/careers' element={<CareersLP />} /> */}
            <Route path='/online-payment' element={<OnlinePayment />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/return-refund-policy' element={<ReturnPolicy />} />
            <Route path='/terms-of-use' element={<TermsofUse />} />
            <Route path='/e-waste-management' element={<EWasteManagement />} />
            <Route path='/responsecheckout/:pageSlug' element={<ResponseCheckout />} />
            {/* Board of Directors Route */}
            <Route path='/board-of-directors' element={<BoardOfDirectorsListing />} /> 
            <Route path='*' element={<NoFound />} />
            {/* for static page */}

          </Routes>

          {/* for login popup */}
          <Modal
            size="lg"
            show={loginmodal}
            backdrop="static"
            keyboard={false}
            contentClassName='border-0 rounded-0'
            onHide={() => handleCloseLogin()}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Body className="p-0">
              <IconButton onClick={() => handleCloseLogin()} aria-label="delete" size="small" className="position-absolute top-0 end-0">
                <CloseIcon fontSize="small" />
              </IconButton>
              <LoginForm />
            </Modal.Body>
          </Modal>
          {/* for login popup */}

          {/* for alert pop */}
          <Snackbar open={msgalert} onClose={handleCloseMsgalert} autoHideDuration={3000}  >
            <Alert onClose={handleCloseMsgalert} severity={msgalertType} sx={{ minWidth: 200 }}>
              {msgalertMessage}
            </Alert>
          </Snackbar>
          {/*  end for alert pop */}

          {/* for tokken check */}
          <Dialog
            // onClose={handleClose}
            open={tokenmodal}
            aria-labelledby="tokencheck"
            aria-describedby="tokencheck"
          >
            <DialogContent className="pb-0">
              <DialogContentText id="tokencheck">
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="head-ti p-4 pb-0">
                      <h3 className="text-danger mb-2">Sorry, your token expired!</h3>
                    </div>
                    <p className="text-center fw-bold mb-0">You need to re-login to continue!</p>
                    <Button className="me-3 mb-4 mt-4 m-auto" variant="contained" color="error"

                      onClick={() => { logout() }}
                    >
                      Ok
                    </Button>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>
          {/* for tokken check */}


          <CookieConsent
            location="bottom"
            buttonText="I Accept"
            declineButtonText="I Decline"
            enableDeclineButton
            onDecline={() => {
              // alert("nay!");
            }}
            onAccept={(acceptedByScrolling) => {
              if (acceptedByScrolling) {
                //alert("Accept was triggered by user scrolling");
              } else {
                // alert("Accept was triggered by clicking the Accept button");
              }
            }}
            cookieName="hondaCookiee"
            style={{ background: "#2B373B" }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
          >
            By using Honda Website, you agree to our <a href="/privacy-policy" className="text-white">Cookie Policy.</a>{" "}
          </CookieConsent>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
